import React, { Component } from "react";
import { List } from "antd";
import LoadingWrapper from "../../components/common/loading-wrapper";
import { getNewsFeed } from "../../services/api";

class News extends Component {
  state = {
    newsItems: [],
    loading: false
  };

  componentDidMount() {
    this._isMounted = true;
    this._getNewsFeed();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <LoadingWrapper loading={this.state.loading}>
        <List
          itemLayout="horizontal"
          dataSource={this.state.newsItems}
          renderItem={item => (
            <List.Item style={{ padding: "8px 24px" }}>
              <List.Item.Meta
                title={
                  <a href={item.link} target="_new">
                    {item.title}
                  </a>
                }
                description={(new Date(item.pubDate)).toLocaleString()}
              />
            </List.Item>
          )}
        />
      </LoadingWrapper>
    );
  }

  _getNewsFeed = () => {
    if (this._isMounted) this.setState({ loading: true });
    getNewsFeed()
      .then(res => {
        if (this._isMounted)
          this.setState({
            newsItems: res.items || [],
            loading: false
          });
      })
      .catch(() => {
        if (this._isMounted)
          this.setState({
            newsItems: [],
            loading: false
          });
      });
  };
}

export default News;
